import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const WrapperIconStyle = ({ theme }) => ({
  minWidth: '4px',
  borderRadius: '12px',
  backgroundColor: `${theme.palette.background.blue.main}`,
  [theme.breakpoints.up('sm')]: {
    minWidth: 'fit-content',
    padding: '8px'
  }
});

const AlertStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  backgroundColor: `${theme.palette.background.grey.light}`,
  border: `1px solid ${theme.palette.border.main}`
});

export const AlertStyled = styled(Box)(AlertStyle);
export const WrapperIconStyled = styled(Box)(WrapperIconStyle);
